import { cn } from "helper/Utils";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

const Modal = ({ onClose, isOpen, closeBtn = true, backdrop = true, modalClassName, className, closeBtnClassName, children, title }) => {
  useEffect(() => {
    const body = document.querySelector("body");
    if (isOpen) {
      body.classList.add("lock-scroll");
    } else {
      body.classList.remove("lock-scroll");
    }

    // Clean-up in case the component is unmounted
    return () => {
      body.classList.remove("lock-scroll");
    };
  }, [isOpen]);

  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector("header");
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  return (
    <>
      <div
        className={cn(
          "!mx-0 fixed top-0 inset-0 flex justify-center lg:items-center z-[1001] bg-opacity-60 animate-fadeIn",
          backdrop ? "bg-black" : "",
          modalClassName
        )}
      >
        {/* Modal Container */}
        <div
          className={`overflow-hidden relative text-white lg:rounded rounded-none bg-body transform transition-all duration-300 scale-100 w-full mx-auto ${className}`}
        >
          {/* Modal Header*/}
          {title || closeBtn ? (
            <div className="flex items-center justify-between mt-3 pb-[0.3rem] px-4 rounded-t font-bold relative">
              {title}
              {closeBtn && (
                <button
                  onClick={onClose}
                  className={`${closeBtnClassName} text-slate-400 leading-none rounded-lg right-4 outline-none focus:outline-none absolute z-20 w-9 h-9 flex justify-center items-center bg-body border-primary-dark `}
                >
                  <MdClose className="text-gray-400 w-[24px] hover:text-[#fff]" size={30} />
                </button>
              )}
            </div>
          ) : null}

          {/* Modal Content */}
          <div className="overflow-y-auto overflow-x-hidden">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Modal;
